import { render, staticRenderFns } from "./aid.vue?vue&type=template&id=31687cd0&scoped=true"
import script from "./aid.vue?vue&type=script&lang=js"
export * from "./aid.vue?vue&type=script&lang=js"
import style0 from "./aid.vue?vue&type=style&index=0&id=31687cd0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31687cd0",
  null
  
)

export default component.exports